import { reqGetAvailableCities } from './GlobStateRequests'
import withGlobalState from './WithGlobalState'
import SimpleSelect from 'components/SimpleSelect'
import { IUnControlledSelectProps } from './ISelect'
import { CitiesRecoilState } from './CitiesState'

export default withGlobalState<IUnControlledSelectProps>(
  CitiesRecoilState,
  reqGetAvailableCities,
  SimpleSelect
)
